import '../../styles/views/contacts.scss';

const moduleName = 'staticPage';

angular.module(moduleName, []).controller('StaticPageCtrl', () => {});

export default moduleName;
